import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-session", { session_id: sessionId });
        // Clear the fragment so refreshes do not re-trigger
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        toast.success(`Willkommen, ${data.name || data.email}!`);
        nav(data.has_access ? "/plan" : "/paywall", { replace: true });
      } catch (err) {
        toast.error("Google-Anmeldung fehlgeschlagen. Bitte erneut versuchen.");
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, refresh]);

  return (
    <div className="max-w-md mx-auto px-6 py-24 text-center text-slate-600">
      <div className="animate-pulse text-emerald-700 font-semibold">Anmeldung läuft…</div>
      <p className="text-sm mt-3">Einen Moment bitte, wir schließen deine Google-Anmeldung ab.</p>
    </div>
  );
}
